export const INITIATE_CUSTOMER_SEARCH = 'INITIATE_CUSTOMER_SEARCH';
export const CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS';
export const CUSTOMER_SEARCH_RESULT_SELECTED = 'CUSTOMER_SEARCH_RESULT_SELECTED';
export const CUSTOMER_SEARCH_CLEAR_RESULTS = 'CUSTOMER_SEARCH_CLEAR_RESULTS';

export const onCustomerSearchChange = (searchTerm) => ({
  type: INITIATE_CUSTOMER_SEARCH,
  searchTerm,
});

export const GET_SILENT_CUSTOMERS_REQUEST = 'GET_SILENT_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_FAILURE = 'GET_CUSTOMERS_FAILURE';

export const ADD_TAGS_TO_CUSTOMERS = 'ADD_TAGS_TO_CUSTOMERS';
export const ADD_TAGS_TO_CUSTOMERS_SUCCESS = 'ADD_TAGS_TO_CUSTOMERS_SUCCESS';
export const ADD_TAGS_TO_CUSTOMERS_FAILURE = 'ADD_TAGS_TO_CUSTOMERS_FAILURE';

export const REMOVE_TAGS_FROM_CUSTOMERS = 'REMOVE_TAGS_FROM_CUSTOMERS';
export const REMOVE_TAGS_FROM_CUSTOMERS_SUCCESS = 'REMOVE_TAGS_FROM_CUSTOMERS_SUCCESS';
export const REMOVE_TAGS_FROM_CUSTOMERS_FAILURE = 'REMOVE_TAGS_FROM_CUSTOMERS_FAILURE';

export const LAUNCH_CUSTOMER_MARKETPLACE_USERNAMES_MODAL = 'LAUNCH_CUSTOMER_MARKETPLACE_USERNAMES_MODAL';
export const CLOSE_CUSTOMER_DETAILS_MODAL = 'CLOSE_CUSTOMER_DETAILS_MODAL';

const errorFor = (type) => (error) => ({
  type,
  ...error,
});

export const requestGetCustomers = (searchTerm = 'all') => {
  return {
    type: GET_CUSTOMERS_REQUEST,
    searchTerm,
  };
};

export const getCustomersSuccess = (page, pageSize, totalCount, pageData) => ({
  type: GET_CUSTOMERS_SUCCESS,
  page,
  pageSize,
  totalCount,
  pageData,
});

export const silentRequestGetCustomers = () => {
  return {
    type: GET_SILENT_CUSTOMERS_REQUEST,
  };
};

export const getCustomersFailure = errorFor(GET_CUSTOMERS_FAILURE);

export const QUICK_SEARCH_CUSTOMERS_SUCCESS = 'QUICK_SEARCH_CUSTOMERS_SUCCESS';
export const quickSearchCustomersSuccess = ({ page, pageSize, totalCount, pageData, searchTerm }) => ({
  type: QUICK_SEARCH_CUSTOMERS_SUCCESS,
  page,
  pageSize,
  totalCount,
  pageData,
  searchTerm,
});

export const addTagsToCustomers = (customerIds, tagId) => ({
  type: ADD_TAGS_TO_CUSTOMERS,
  customerIds,
  tagId,
});

export const addTagsToCustomersSuccess = ({ customerIds, tagId }) => ({
  type: ADD_TAGS_TO_CUSTOMERS_SUCCESS,
  customerIds,
  tagId,
});

export const addTagsToCustomersFailure = (error) => ({
  type: ADD_TAGS_TO_CUSTOMERS_FAILURE,
  error,
});

export const removeTagsFromCustomers = (customerIds, tagId) => ({
  type: REMOVE_TAGS_FROM_CUSTOMERS,
  customerIds,
  tagId,
});

export const removeTagsFromCustomersSuccess = ({ customerIds, tagId }) => ({
  type: REMOVE_TAGS_FROM_CUSTOMERS_SUCCESS,
  customerIds,
  tagId,
});

export const removeTagsFromCustomersFailure = (error) => ({
  type: REMOVE_TAGS_FROM_CUSTOMERS_FAILURE,
  error,
});

export const launchCustomerMarketplaceUsernamesModal = (marketplaces) => ({
  type: LAUNCH_CUSTOMER_MARKETPLACE_USERNAMES_MODAL,
  marketplaces,
});

export const closeDetailsModal = () => ({
  type: CLOSE_CUSTOMER_DETAILS_MODAL,
});

export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';

export const createCustomerSuccess = () => ({
  type: CREATE_CUSTOMER_SUCCESS,
});

export const deleteCustomerSuccess = () => ({
  type: DELETE_CUSTOMER_SUCCESS,
});

export const updateCustomerSuccess = () => ({
  type: UPDATE_CUSTOMER_SUCCESS,
});
